import { render, staticRenderFns } from "./PanelsListByThematicPath.vue?vue&type=template&id=6295c50d&scoped=true"
import script from "./PanelsListByThematicPath.vue?vue&type=script&lang=js"
export * from "./PanelsListByThematicPath.vue?vue&type=script&lang=js"
import style0 from "./PanelsListByThematicPath.vue?vue&type=style&index=0&id=6295c50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295c50d",
  null
  
)

export default component.exports